import type { common as commonEn } from "../en/common";

export const common: typeof commonEn = {
  admin: "Admin",
  settings: "Nastavení",
  logout: "Odhlásit se",
  actions: {
    save: "Uložit",
    saving: "Ukládám…",
    create: "Vytvořit",
    add: "Přidat",
    edit: "Upravit",
    delete: "Smazat",
    duplicate: "Duplikovat",
    cancel: "Zrušit",
    close: "Zavřít",
    back: "Zpět",
    confirm: "Potvrdit",
    search: "Hledat",
    filter: "Filtrovat",
    clear: "Vymazat",
    reset: "Obnovit výchozí",
    refresh: "Obnovit",
    upload: "Nahrát",
    download: "Stáhnout",
    preview: "Náhled",
    copy: "Kopírovat",
    send: "Odeslat",
    retry: "Zkusit znovu",
    showMore: "Zobrazit více",
    showLess: "Zobrazit méně",
    select: "Vybrat",
    remove: "Odebrat",
    archive: "Archivovat",
    moveUp: "Posunout nahoru",
    moveDown: "Posunout dolů",
    viewOnWeb: "Zobrazit na webu",
    export: "Exportovat",
    open: "Otevřít",
    apply: "Použít",
  },
  states: {
    loading: "Načítám…",
    noResults: "Žádné výsledky",
    empty: "Zatím tu nic není",
    error: "Něco se pokazilo",
    notFound: "Nenalezeno",
    saved: "Uloženo",
    deleted: "Smazáno",
    unsavedChanges: "Neuložené změny",
  },
  status: {
    draft: "Koncept",
    published: "Publikováno",
    archived: "Archivováno",
    active: "Aktivní",
    inactive: "Neaktivní",
  },
  fields: {
    name: "Název",
    title: "Titulek",
    slug: "Slug",
    description: "Popis",
    status: "Stav",
    date: "Datum",
    email: "E-mail",
    phone: "Telefon",
    note: "Poznámka",
    notes: "Poznámky",
    sortOrder: "Pořadí",
    created: "Vytvořeno",
    updated: "Upraveno",
    actions: "Akce",
    type: "Typ",
    image: "Obrázek",
    link: "Odkaz",
    price: "Cena",
    currency: "Měna",
    customer: "Zákazník",
    trip: "Zájezd",
    destination: "Destinace",
    total: "Celkem",
  },
  confirmDelete: "Opravdu chcete tuto položku smazat?",
  itemsCount_one: "{{count}} položka",
  itemsCount_few: "{{count}} položky",
  itemsCount_other: "{{count}} položek",
  pagination: {
    previous: "Předchozí",
    next: "Další",
    pageOf: "Strana {{page}} z {{total}}",
  },
  toasts: {
    saved: "Uloženo",
    created: "Vytvořeno",
    deleted: "Smazáno",
    duplicated: "Duplikováno",
    copied: "Zkopírováno do schránky",
    saveFailed: "Uložení se nezdařilo",
    deleteFailed: "Smazání se nezdařilo",
  },
  language: {
    cs: "Čeština",
    en: "English",
  },
};
